{
  "header": "Check your mobile device",
  "inputs": {
    "mobile-verification-code": {
      "label": "",
      "isRequired": true,
      "maxLength": 5,
      "type": "tel",
      "mask": "00000",
      "validity": [
        ["required", "5-digit Verification Code required", "ignore label"],
        [
          "requiredLength5",
          "Verification code must be 5 digits",
          "ignore label"
        ]
      ]
    }
  },
  "sms": {
    "uplift": {
      "label": "<span>Enter the <strong>5-digit code</strong> sent to <strong>{{phoneNumber}}</strong> via <strong>SMS</strong> by <strong>Uplift</strong>.</span>"
    },
    "flexpay": {
      "label": "<span>Enter the <strong>5-digit code</strong> sent to <strong>{{phoneNumber}}</strong> via <strong>SMS</strong> by <strong>Flex Pay</strong>.</span>"
    },
    "resend-code": "Resend code",
    "check-mobile": "Please check that your mobile number is correct.",
    "resend-now": "Resend now"
  },
  "submit": "Verify"
}
